module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAA+ElEQVRoQ+2XQQrCMBBFJ1Bw7RlceTPJwuMEE9z1XJ7BCyREunQj09D/kfC7nsz0/ReSNtgkT5iEwwTybyZlREZACWhrgYIdbisjw9GBFsoIKNjhtjIyHB1ooYz8CraU8uy9n1pr9xjjGyThqy3ESM55DSFczexVa70xYCAgKaXzsiwPM7uwYCAgm3M2DAyEDQMFYcLAQVgwFBAGDA0EDSOQvbc1+jimGEFDbKHCQRgQcBAWBBSECQEDYUPAQKb5jJ/mx2rvHXNEPfz4PeIlPT0E4kmJWSMjzLQ9s2TEkxKzRkaYaXtmyYgnJWaNjDDT9sySEU9KzJoPDkKmM0FTKiMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ou@2x.png
// module id = G3hz
// module chunks = 1